import { useEffect, useMemo, useRef } from 'react'
import { debounce } from 'lodash'

export const useDebounce = (callback: any, time: number = 1000) => {
  const ref = useRef()

  useEffect(() => {
    ref.current = callback
  }, [callback])

  const debouncedCallback = useMemo(() => {
    const func = (args?: any) => {
      // @ts-ignore
      ref.current?.(args)
    }

    return debounce(func, time)
  }, [time])

  return debouncedCallback
}
